import { useCallback } from 'react'
import _ from 'lodash'
import { clearReferences } from '../utils'

export default ({ onChange, model, field, appliance, selectStep }) => {
  const handleDeleteStep = useCallback(({
    index,
    typePath,
  }) => {
    let path = `values[${field}].${typePath}`
    let deleteErrorsPath = `values[${field}].${typePath}`
    const step = _.get(model, `values[${field}].${typePath}[${index}]`)
    const newItems = _.get(model, path, []).filter((i, itemIndex) => itemIndex !== index)
    let toSelect = null
    if (newItems.length > 0) {
      const indexToSelect = Math.min(index, newItems.length - 1)
      toSelect = `${typePath}[${indexToSelect}]`
    }

    onChange({
      target: {
        value: newItems,
        name: path,
      },
    }, (model, modifyUtils) => clearReferences(
      modifyUtils.correctErrorsAfterDeleteItem(model, deleteErrorsPath, index),
      step, appliance, field))
    selectStep(toSelect)
  }, [appliance, field, model, onChange, selectStep])
  return handleDeleteStep
}
